import { useMediaQuery } from '@react-hook/media-query';
import { useEffect, useState } from 'react';

import useGetUserAgent from './useGetUserAgent';

const tabletQuery = '(min-width: 768px) and (max-width: 1023px)';

const useIsTabletSize = () => {
  const isMediaTablet = useMediaQuery(tabletQuery);
  const { isTablet } = useGetUserAgent();
  const [isDeviceTablet, setIsDeviceTablet] = useState(isTablet);
  useEffect(() => {
    setIsDeviceTablet(isMediaTablet);
  }, [isMediaTablet]);
  return isDeviceTablet;
};

export default useIsTabletSize;
